import {
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Stack,
} from "@mui/material";
import { useCallback } from "react";

import { useQueryParams } from "../../../../../hooks/useQueryParams";
import OrderingArrow from "../../../../global/OrderingArrow";
import PermissionWrapper from "../../../../global/PermissionWrapper";
import HNSColors from "../../../../ui library/HNSColors";
import { useViewDocumentsPermissions } from "../../hooks/useViewDocumentsPermissions";

export default function DocumentsTableHead({
  documentsList,
  setDocumentsList,
  updateSelectedDocs,
  enableThreeDotMenu,
  canAddAssociation,
  isDocumentsPage,
  hasDocuments,
}) {
  const { canExportAllDocuments, canViewCheckCheckbox, canViewApprovalCheckbox } = useViewDocumentsPermissions();

  const allDocsSelected = documentsList?.every((doc) => doc?.selected);
  const someDocsSelected = documentsList?.some((doc) => doc?.selected);

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    const updatedDocList = documentsList?.map((doc) => ({ ...doc, selected: isChecked }));
    setDocumentsList(updatedDocList);
    updatedDocList.forEach((doc) => updateSelectedDocs(doc?.id, isChecked));
  };

  const { filters, updateFilter } = useQueryParams();
  const ordering = filters.get("ordering");

  const handleOrderingChange = useCallback(
    (newOrdering) => {
      updateFilter("ordering", newOrdering);
    },
    [updateFilter]
  );

  return (
    <TableHead>
      <TableRow>
        {!isDocumentsPage && hasDocuments && (
          <PermissionWrapper permission={canExportAllDocuments}>
            <TableCell
              padding="checkbox"
              sx={{
                backgroundColor: "background.paper",
                zIndex: 2,
              }}
            >
              <Tooltip title="Select All">
                <Checkbox
                  sx={{
                    transform: "scale(1.2)",
                    "&.Mui-checked": {
                      color: `${HNSColors.primary[500]}`,
                    },
                    "&.MuiCheckbox-indeterminate": {
                      color: `${HNSColors.primary[500]}`,
                    },
                  }}
                  onChange={handleSelectAll}
                  checked={allDocsSelected}
                  indeterminate={!allDocsSelected && someDocsSelected}
                />
              </Tooltip>
            </TableCell>
          </PermissionWrapper>
        )}
        {isDocumentsPage && (
          <TableCell>
            <Stack direction="row" alignItems="center">
              <Typography fontWeight={600}>Client</Typography>
              <OrderingArrow
                val="client_name"
                orderingVal={ordering}
                setOrderingVal={handleOrderingChange}
              />
            </Stack>
          </TableCell>
        )}
        <TableCell>
          <Stack direction="row" alignItems="center">
            <Typography fontWeight={600}>Document Name</Typography>
            <OrderingArrow
              val="file_name"
              orderingVal={ordering}
              setOrderingVal={handleOrderingChange}
            />
          </Stack>
        </TableCell>
        <TableCell>
          <Stack direction="row" alignItems="center">
            <Typography fontWeight={600}>Type</Typography>
            <OrderingArrow
              val="document_type_label"
              orderingVal={ordering}
              setOrderingVal={handleOrderingChange}
            />
          </Stack>
        </TableCell>
        <TableCell>
          <Stack direction="row" alignItems="center">
            <Typography fontWeight={600}>Source</Typography>
            <OrderingArrow
              val="source_label"
              orderingVal={ordering}
              setOrderingVal={handleOrderingChange}
            />
          </Stack>
        </TableCell>
        <TableCell>
          <Typography fontWeight={600}>Provider</Typography>
        </TableCell>
        <TableCell>
          <Typography fontWeight={600}>Related Appointments</Typography>
        </TableCell>
        {canViewCheckCheckbox && <TableCell>
          <Typography fontWeight={600}>Checked</Typography>
        </TableCell>}
        {canViewApprovalCheckbox && <TableCell>
          <Typography fontWeight={600}>Approved</Typography>
        </TableCell>}
        <PermissionWrapper permission={enableThreeDotMenu || canAddAssociation}>
          <TableCell></TableCell>
        </PermissionWrapper>
      </TableRow>
    </TableHead>
  );
}
